<template>
  <!-- 機器管理 -->
  <div id="DeviceManagement">
    <div id="container">
      <deviceNavi v-bind:pageid='"DeviceManagement"'></deviceNavi>
      <div class="labelTitle lable">機器一覧</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>種別</th>
            <td>
              <select v-model="searchCondition.inspectionKind">
                <option v-for="kind of kindList" :value="kind.value" :key="'s' + kind.value">
                  {{kind.kind}}
                </option>
              </select>
            </td>
            <th>品目コード</th>
            <td><input v-model="searchCondition.itemCode" type="text" /></td>
            <th>状態</th>
            <td>
              <select v-model="searchCondition.status">
                <option v-for="machineStatus of machineStatusList" :value="machineStatus.value" :key="'s' + machineStatus.value">
                  {{machineStatus.label1}}
                </option>
              </select>
            </td>
            <th>シリアル</th>
            <td><input v-model="searchCondition.serial" @keyup.enter="onKeyupEnter()" type="text" /></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="operationButton is-primary" icon-left="clipboard-arrow-right-outline" @click="goStatusChange">状態一括変更</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <span v-if="data.length > 0" class="result-count">件数：{{data.length}}件</span>
      <div class="result-area" v-if="data.length > 0">
        <b-table
            id="deviceListTable"
            :data="data"
            default-sort="serial">
            <template slot-scope="props">
              <b-table-column label="#" width="50" centered>{{props.index +1}}</b-table-column>
              <b-table-column field="serial" label="シリアル" width="120" sortable centered>
                <router-link :to="{name:'DeviceManagementDetail', params:{data:props.row, searchCondition: searchCondition}}">{{props.row.serial}}</router-link>
              </b-table-column>
              <b-table-column field="inspectionKind" label="種別" width="170" sortable >
                {{props.row.inspectionKind }}
              </b-table-column>
              <b-table-column field="itemCode" label="品目コード" width="80" sortable centered>
                {{props.row.itemCode }}
              </b-table-column>
              <b-table-column field="itemName" label="品目名称" sortable >
                {{props.row.itemName}}
              </b-table-column>
              <b-table-column field="status" label="状態" width="110" centered sortable >
                  <span :class="getMachineStatusTagClass(props.row.statusCode)">
                    {{props.row.status}}
                  </span>
              </b-table-column>
              <b-table-column field="scheduledReturnDate" label="返却日" width="80" centered sortable >
                <template v-if="props.row.statusCode == machineStatus.deviceReady || props.row.statusCode == machineStatus.shipping || props.row.statusCode == machineStatus.overdue || props.row.statusCode == machineStatus.depositShipping || props.row.statusCode == machineStatus.depositScheduledReturned">
                  {{replaceSlash(props.row.scheduledReturnDate)}}
                </template>
              </b-table-column>
              <b-table-column field="storageLocation" label="保管場所" width="200" sortable >
                {{props.row.storageLocation}}
              </b-table-column>
              <b-table-column field="warehousingDate" label="入庫日" width="80" centered sortable >
                {{replaceSlash(props.row.warehousingDate)}}
              </b-table-column>
              <b-table-column field="leaseStartDate" label="リース開始日" width="90" centered sortable >
                {{replaceSlash(props.row.leaseStartDate)}}
              </b-table-column>
              <b-table-column field="leaseEndDate" label="リース終了日" width="90" centered sortable >
                {{replaceSlash(props.row.leaseEndDate)}}
              </b-table-column>
              <b-table-column field="leaseUpDate" label="リースアップ日" width="110" centered sortable >
                {{replaceSlash(props.row.leaseUpDate)}}
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {machineStatus} from "@/components/mock/base/const.js";
import naviBar from "@/components/mock/philips/device/DeviceNaviBar";

export default {
  name: "DeviceManagement",
  methods: {
    hasSearchCondition: function(searchConditions) {
      var isSearchParam = false
      var keys = Object.keys(searchConditions)
      for(var i=0; i < keys.length; i++){
        if(searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      return isSearchParam;
    },
    doSearch: function(){
      if(!this.hasSearchCondition(this.searchCondition)){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }

      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceListPOST({
            body:{
              exactMatch: false,
              inspectionKind: _this.searchCondition.inspectionKind,
              itemCode: _this.searchCondition.itemCode,
              status: _this.searchCondition.status,
              serial: _this.searchCondition.serial,
            }
          });
        },
        function(result){
          _this.data = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    onKeyupEnter: function() {
      if (this.searchCondition.serial) {
        let serialItems = this.searchCondition.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          this.searchCondition.serial = serialItems[1]
        }
      }
    },
    goStatusChange: function(){
      this.$router.push({
        name: "DeviceStatusBulkChange",
        params: {}
      });
    },
    getDeviceKinds: function(){
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceKindsPOST({
            body:{}
          });
        },
        function(result){
          var kindList = result.obj
          kindList.unshift({value: ""});
          _this.kindList = kindList
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
  },
  data() {
    let machineStatusList = this.getChoiceList(choicesType.machineStatus, true)
    machineStatusList.unshift({value: ""});

    return {
      data : [],
      searchCondition: {
        inspectionKind: "",
        itemCode: "",
        status: "",
        serial: "",
      },
      machineStatusList: machineStatusList,
      machineStatus: machineStatus,
      kindList: []
    };
  },
  filters: {},
  components: {
    deviceNavi: naviBar
  },
  mounted: async function() {
    this.getDeviceKinds();
    var searchCondition = this.$route.params["searchCondition"];
    if(searchCondition){
      if (this.hasSearchCondition(searchCondition)) {
        this.searchCondition = searchCondition;
        this.doSearch();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}
.operation-area {
  width: 1000px;
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
}
.operationButton {
  width:200px;
  float:right;
  margin-top:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/DeviceManagement.vue